export const mustBeTrue = (message?: string) => (value: boolean) => {
  if (!value) {
    return message || 'Ce champ est obligatoire';
  }
  return undefined;
};
